'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ActionTypes = require('pricing-pages-unified-ui/constants/ActionTypes');

var billingTerms = function billingTerms() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes.BILLING_TERMS_RECEIVED:
      return payload;
    default:
      return state;
  }
};

exports.default = billingTerms;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers/BillingTerms.js
// module id = 382
// module chunks = 3 4 5